import { createStrictContext, useStrictContext } from '../../lib/react';

import { TConfirmationContext } from './types';

export const confirmationContext = createStrictContext<TConfirmationContext>();

/**
 * Hook для работы с диалогом подтверждения
 *
 * @example
 * // shouldCloseOnConfirm: true (по умолчанию) - диалог закрывается сразу при нажатии "Подтвердить"
 * const { getConfirmation } = useGetConfirmation();
 *
 * const handleSimpleAction = async () => {
 *   const isConfirmed = await getConfirmation({
 *     shouldCloseOnConfirm: true
 *   });
 *   if (isConfirmed) {
 *     // Диалог уже закрыт, выполняем действие
 *     await simpleAction();
 *   }
 * };
 *
 * @example
 * // shouldCloseOnConfirm: false - диалог остается открытым, нужно закрывать вручную
 * const { getConfirmation, setPending, closeConfirmation } = useGetConfirmation();
 *
 * const handleAsyncAction = async () => {
 *   const isConfirmed = await getConfirmation(); // shouldCloseOnConfirm: false по умолчанию
 *   if (isConfirmed) {
 *     setPending(true); // Показываем загрузку в диалоге
 *     try {
 *       await asyncAction(); // Выполняем долгую операцию
 *     } finally {
 *       closeConfirmation(); // Закрываем диалог после завершения
 *     }
 *   }
 * };
 *
 */
export const useGetConfirmation = () => {
  return useStrictContext(confirmationContext);
};
